import Vue from "vue";
import VueSocketIO from "vue-socket.io";

import store from "@/store";
import { IS_PRODUCTION } from "@/env";

const socket = Vue.use(
  new VueSocketIO({
    debug: IS_PRODUCTION ? false : true,
    connection: IS_PRODUCTION
      ? `wss://${process.env.VUE_APP_B2B_ENDPOINT}/b2b_admin`
      : // ? "wss://stagsing.cleed.ai/b2b_admin"
        "ws://localhost:48080/b2b_admin",
    vuex: {
      store,
      options: {
        useConnectionNamespace: true,
      },
      actionPrefix: "SOCKET_",
      mutationPrefix: "SOCKET_",
    },
    options: {
      query: {
        r_var: store.state.admin.storeId,
        token: store.state.admin.token,
      },
    },
  })
);

export default socket;
